import { connect } from 'react-redux';

import * as ownFunctions from './Proyection.General.Functions';
import { PageHeader } from '../../commons/component/PageHeader/PageHeader';
import FinancialPanelComponent from '../../components/Proyections/FinancialPanel/FinancialPanel.Component';

/**
 * Panel financiero del centro.
 *
 * La página no decide nada: arma el encabezado y monta el panel, que es el que
 * ordena los tres bloques —caja, rentabilidad y proyección— y maneja sus filtros.
 */
const ProyectionGeneralPage = (_props: ownFunctions.Props) => (
    <>
        <PageHeader title="Panel financiero" />
        <FinancialPanelComponent />
    </>
);

export default connect(
    ownFunctions.mapStateToProps,
    ownFunctions.mapDispatchToProps
)(ProyectionGeneralPage as any);
